const deepClone = (value, hash = /* @__PURE__ */ new WeakMap()) => {
  if (typeof value !== "object" || value === null) {
    return value;
  }
  if (hash.has(value)) {
    return hash.get(value);
  }
  const result = Array.isArray(value) ? [] : {};
  hash.set(value, result);
  Object.keys(value).forEach((key) => {
    result[key] = deepClone(value[key], hash);
  });
  return result;
};
export {
  deepClone
};
//# sourceMappingURL=deep-clone.js.map
